import { useViewport } from 'hooks/3catinfo/useViewport';
import Titol from 'components/3catinfo/Titol';
import Compartir from 'components/3catinfo/Compartir';
import styles from './capcaleraTemps.module.scss';
import CercaMunicipi from 'components/3catinfo/CercaMunicipi';
import clsx from 'clsx';
import BotoSeguir from 'components/3catinfo/BotoSeguir';

const getSeason = () => {
    const dataActual = new Date();
    const dia = dataActual.getDate();
    const mes = dataActual.getMonth() + 1;

    if ((mes === 12 && dia >= 21) || mes === 1 || mes === 2 || (mes === 3 && dia < 21)) {
        return 'hivern';
    } else if ((mes === 3 && dia >= 21) || mes === 4 || mes === 5 || (mes === 6 && dia < 21)) {
        return 'primavera';
    } else if ((mes === 6 && dia >= 21) || mes === 7 || mes === 8 || (mes === 9 && dia < 21)) {
        return 'estiu';
    } else {
        return 'tardor';
    }
};

const CapcaleraTemps = (props) => {
    const { mostraAccions = true, tag, titol, compartir = true, estacions } = props;
    const { zoomNavigator } = useViewport();
    const season = getSeason();
    const imatgeEstacio = estacions?.[season];

    const stylesContentShared = clsx({
        [styles.contentShared]: true,
        [styles.ambZoom]: zoomNavigator > 3
    });

    return (
        <div className={styles.capcalera} style={{ backgroundImage: `url(${imatgeEstacio})` }}>
            <div className={styles.capcaleraWrapper}>
                <div className={styles.titolWrapper}>
                    <Titol tag={tag} titol={titol} tipus='seccio' />
                    {mostraAccions && (
                        <div className={stylesContentShared}>
                            <div className={styles.seguir}>
                                <BotoSeguir
                                    obreEsquerra={false}
                                    id={53382}
                                    textHitAudiencies={'METEOROLOGIA'}
                                    tipologia={'DTY_CATEGORY'}
                                    estil='petit'
                                    enviaApi={true}
                                />
                            </div>
                            <div className={styles.cercador}>
                                <CercaMunicipi
                                    placeholder='Cerca per municipi'
                                    inpuId='search-capcalera'
                                    estil='tendencia'
                                    estilIcon='taronja'
                                    routePath='web_3catinfo_el_temps_municipi'
                                    getTitle={(item) => `Previsió del temps a ${item.nom}${item.detall || ''}`}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles.imageWrapper} style={{ backgroundImage: `url(${imatgeEstacio})` }}></div>
            </div>
        </div>
    );
};

export default CapcaleraTemps;
